module.exports = __webpack_public_path__ + "img/larrykingroundtrans.a2e420a4.webp";